import { EventDefinition } from '@wix/sdk-types';
import { createRedirectSession as universalCreateRedirectSession, } from './headless-v1-redirect-session-redirects.universal';
export const __metadata = { PACKAGE_NAME: '@wix/redirects' };
export function createRedirectSession(httpClient) {
    return (options) => universalCreateRedirectSession(options, 
    // @ts-ignore
    { httpClient });
}
const _redirectSession = {};
export const onRedirectSessionCreated = EventDefinition('wix.headless.v1.redirect_session_created', true, {
    rootSchema: _redirectSession,
    depSchemas: {},
})();
export { LocationType, Prompt, MembersAccountSection, CallbackType, WebhookIdentityType, } from './headless-v1-redirect-session-redirects.universal';
//# sourceMappingURL=headless-v1-redirect-session-redirects.public.js.map